import ApiService from '@/services/api.service.js';

export const DashboardService =
{
    getDashboardData: function (data)
    {
        return ApiService.post('/dashboard', data);
    },
    getFilters: function (data)
    {
        return ApiService.post('/dashboard/filters', data);
    },
}

export default DashboardService
